"use client";

import { useEffect } from "react";
import { registerServiceWorker } from "@/lib/push";

export function PwaShell() {
  useEffect(() => {
    void registerServiceWorker();
  }, []);
  return null;
}
